<template>
  <div
    class="product-list-item"
    :class="[{ sale: isSale }, { soldOut: item.minUnitPrice === 0 }, { 'list-card': isCard }, { detail: variant === 'detail' }]"
  >
    <div class="thumb-col">
    <!-- 카드형: 썸네일 위 브랜드 로고 -->
    <img
      v-if="showThumbLogo"
      class="thumb-logo"
      :src="brand.image"
      :alt="brand.name"
      :title="brand.name"
      @click.stop="goDetail(brand.id, 'brand')"
      @error="logoFailed = true"
    />
    <div class="imgbox">
      <img :src="image" />
      <div class="wish-background"></div>
      <input
        v-if="isWish"
        class="wish"
        type="checkbox"
        v-model="item.isWish"
        @change="
          !isHistory && !item.isWishProductInfo
            ? changeWish(item.catalogId, item.isWish, 'catalog')
            : changeWish(
                item.isWishProductInfo
                  ? item.productInfos[0].productInfoId
                  : item.productInfoId,
                item.isWish,
                'productInfo'
              )
        "
      />
    </div>
    </div>

    <!-- 제품 정보 영역 -->
    <div
      class="product-info"
      style="height: 140px"
      @click="
        !isHistory && !item.isWishProductInfo
          ? goSearchResult()
          : goProductDetail()
      "
    >
      <div class="info">
        <!-- 커머스형(variant="card"): 브랜드를 제품명 위에 표시 -->
        <div
          class="brand-line"
          v-if="isCard && ((brand && brand.name) || item.code)"
        >
          <span
            class="brand-name"
            v-if="brand && brand.name && !showThumbLogo"
            @click.stop="goDetail(brand.id, 'brand')"
            v-html="replaceHighlight(brand.name)"
          ></span>
          <span
            class="item-code"
            v-if="item.code"
            @click.stop="goDetail(item.code, 'code')"
          >
            제품번호 <b v-html="replaceHighlight(item.code)"></b>
          </span>
        </div>
        <!-- 제품명 + 서브명 (카드형에서는 3줄까지만 보이고 넘치면 ... 처리, 전체는 마우스를 올리면 툴팁) -->
        <div
          class="title-line"
          :title="item.subname ? `${item.name} ${item.subname}` : item.name"
        >
          <div class="title-text">
            <h6 class="name" v-html="replaceHighlight(item.name)"></h6>
            <p
              class="subname"
              v-if="item.subname"
              v-html="replaceHighlight(item.subname)"
            ></p>
          </div>
        </div>

        <div class="price-wrapper">
          <h5 v-if="item.discountPercent > 0" class="dicount">
            {{ roundNum(item.discountPercent) }}%
          </h5>

          <!-- 가격/견적문의 표시 -->
          <h5 class="price">
            <template v-if="item.minSellingUnitPrice > 0">
              <span
                v-html="replaceHighlight(CommaNum(item.minSellingUnitPrice))"
              ></span
              >원
              <span v-if="productInfos && productInfos.length > 0">~</span>
            </template>
            <!-- 0원: 견적 문의 (카드형은 버튼 모양, 그 외 화면은 기존 표시) -->
            <div v-else-if="isCard" class="inquiry">
              <a class="inquiry-btn" href="mailto:lab@lab-manager.com" @click.stop
                >견적 문의</a
              >
              <span class="inquiry-mail">lab@lab-manager.com</span>
            </div>
            <template v-else>
              <a
                href="mailto:lab@lab-manager.com"
                style="font-weight: bold; color: red"
                @click.stop
              >
                lab@lab-manager.com 견적문의
              </a>
            </template>
          </h5>

          <!-- 원가(할인전) - 할인 존재 시에만, 그리고 0원일 때는 숨김 -->
          <h6
            class="original-price"
            v-if="item.discountPercent && item.minUnitPrice > 0"
          >
            {{ CommaNum(item.minUnitPrice) }}원
          </h6>
        </div>
      </div>

      <div class="brand-info">
        <p v-if="item.category && !isCard" @click="goDetail(item.category, 'category')">
          카테고리:
          <span
            v-html="
              replaceHighlight(
                `${item.category.korName}${
                  item.category.parents.length
                    ? '/' + item.category.parents[0].korName
                    : ''
                }`
              )
            "
          ></span>
        </p>
        <p v-if="brand && brand.name && !isCard" @click.stop="goDetail(brand.id, 'brand')">
          브랜드: <span v-html="replaceHighlight(brand.name)"></span>
        </p>
        <p v-if="item.code && !isCard" @click.stop="goDetail(item.code, 'code')">
          제품번호: <span v-html="replaceHighlight(item.code)"></span>
        </p>
        <p v-if="item.casno" @click.stop="goDetail(item.casno, 'casno')">
          CAS No: <span v-html="replaceHighlight(item.casno)"></span>
        </p>
        <p v-if="productOptions.length > 0" class="product-option">
          <span v-html="replaceHighlight(productOptions)"></span>
        </p>
      </div>

      <div class="count-info" v-if="isShowOrderCount">
        <p>{{ item.orderCount }}<span>번 주문</span></p>
      </div>
    </div>

    <!-- 우측 판매자별 가격 리스트 -->
    <div class="price-box" v-if="!isSale && !isCard">
      <ul v-if="!isHistory">
        <li
          v-for="(product, index) in productInfos.slice(0, 4)"
          :key="index"
          @click="goProductDetail(product.productInfoId)"
        >
          <b>{{ product.seller ? product.seller.name : "판매자" }}</b>
          <img
            v-if="item.shippingDayPolicy === 'SHAK'"
            src="@/assets/svg/shackshack-text.svg"
          />
          <p class="detail-price">
            {{
              product.minSellingUnitPrice > 0
                ? CommaNum(product.minSellingUnitPrice) + "원"
                : "견적문의"
            }}
          </p>
        </li>
        <button
          v-if="productInfos.length > 4"
          @click="!isHistory ? goSearchResult() : goProductDetail()"
        >
          더보기
        </button>
      </ul>

      <!-- 히스토리 모드 -->
      <ul v-else>
        <li>
          <b @click="goSellerInfo(item.seller.id)">{{
            item.seller ? item.seller.name : "판매자"
          }}</b>
          <p class="detail-price">
            {{
              item.minSellingUnitPrice > 0
                ? CommaNum(item.minSellingUnitPrice) + "원"
                : "견적문의"
            }}
          </p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import mixin from "@/mixins";
import PageName from "@/utils/define/PageName";
import RoutePath from "@/utils/define/RoutePath";
import { getBaseURL } from "@/services/api/common";

export default {
  name: "ProductListItem",
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    isWish: {
      type: Boolean,
      default: true,
    },
    highlightValue: {
      type: String,
      default: "",
    },
    mode: {
      type: String,
      default: "",
    },
    // "" (기본) | "card" (검색 화면: 카드형, 카테고리/판매자별 가격 숨김)
    variant: {
      type: String,
      default: "",
    },
  },
  mixins: [mixin],
  data() {
    return {
      // 브랜드 로고 이미지를 불러오지 못하면 브랜드명 글자로 대신 보여준다
      logoFailed: false,
    };
  },
  computed: {
    // 카드형(목록 카드, 상품 판매 페이지)은 썸네일 위에 브랜드 로고를 보여준다
    showThumbLogo() {
      return this.isCard && !!(this.brand && this.brand.image) && !this.logoFailed;
    },
    isCard() {
      return this.variant === "card" || this.variant === "detail";
    },
    image() {
      return this.item.images && this.item.images[0]
        ? this.item.images[0].url ?? this.item.images[0]
        : require("@/assets/svg/empty_product.svg");
    },
    isSale() {
      return this.mode == "sale";
    },
    isHistory() {
      return !this.item.productInfos;
    },
    productInfos() {
      return this.item.productInfos;
    },
    brand() {
      return this.item.brand;
    },
    productOptions() {
      if (this.$_.isEmpty(this.item) || !this.item.categoryDisplayOptions)
        return [];

      let result = "";
      this.item.categoryDisplayOptions.forEach((option, index) => {
        result += (index > 0 ? " | " : "") + option.name + ": ";
        option.values.forEach((value, innerIndex) => {
          result += (innerIndex > 0 ? ", " : "") + value;
        });
      });
      return result;
    },
    isShowOrderCount() {
      return this.$route.path === "/frequentlyOrderList";
    },
  },
  methods: {
    // 0원일 때 이동 차단 (로직 가드)
    async goSearchResult() {
      if (this.item?.minUnitPrice === 0) return;
      if (!this.isSale) {
        this.$emit("searchSuccess", {
          itemType: "catalog_id",
          itemValue: this.item.catalogId,
        });
        this.windowOpen({
          PageName: PageName.ProductSale,
          RoutePath: RoutePath.ProductSale,
          params: {
            category: "list",
            id: this.item.catalogId,
          },
        });
      }
    },
    goProductDetail(id) {
      if (this.item?.minUnitPrice === 0) return;
      const productInfoId =
        id ??
        (this.item.isWishProductInfo
          ? this.item.productInfos[0].productInfoId
          : this.item.productInfoId);
      this.$emit("searchSuccess", {
        itemType: "product_info_id",
        itemValue: productInfoId,
      });
      this.windowOpen({
        PageName: PageName.Detail,
        RoutePath: RoutePath.Detail,
        params: {
          category: "list",
          productInfoId: productInfoId,
        },
      });
    },
    goSellerInfo(id) {
      this.$router.push({
        name: PageName.Search,
        params: {
          category: "seller",
        },
        query: {
          id: id,
        },
      });
    },
    replaceHighlight(value) {
      let regex = new RegExp(this.highlightValue, "gi");
      return this.highlightValue
        ? value.replace(
            regex,
            (match) => `<mark class="hightlight">${match}</mark>`
          )
        : value;
    },
    goDetail(keyword, type) {
      if (type === "brand") {
        this.$router
          .push({
            name: PageName.Search,
            params: {
              category: type,
            },
            query: {
              id: keyword,
            },
          })
          .catch(() => {});
      } else if (type === "code") {
        this.$router
          .push({
            name: PageName.SearchList,
            query: {
              keyword,
              type: "ALL",
            },
          })
          .catch(() => {});
      } else if (type === "casno") {
        this.$emit("searchSuccess", {
          itemType: "casno",
          itemValue: keyword,
        });
        this.$router
          .push({
            name: PageName.SearchList,
            query: {
              keyword,
              type: "CASNO",
            },
          })
          .catch(() => {});
      } else if (type === "category") {
        this.$router
          .push({
            name: PageName.SearchList,
            query: {
              classification: keyword.parents.length
                ? keyword.parents[0].code
                : keyword.code,
              tags: keyword.parents.length
                ? keyword.parents[0].korName
                : keyword.korName,
            },
          })
          .catch(() => {});
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.product-list-item {
  width: 100%;
  display: flex;
  align-items: flex-start;
  border-bottom: 1px solid $LINE_DIVIDER;
  padding: 20px 0;
  cursor: pointer;

  &:hover {
    .wish-background {
      display: inline-block;
    }
    .wish {
      &:not(:checked):not(:hover):after {
        background-image: url(~@/assets/svg/unchecked-favor-hover.svg);
      }
    }
  }

  &.sale {
    cursor: default;
    padding: 0 0 20px 0;
  }

  /* 0원: 오버레이 제거 + 클릭 차단(내용영역만) */
  &.soldOut {
    cursor: default; /* 시각적으로도 클릭 아님을 표현 */

    /* 기존 반투명 오버레이 제거 */
    &:after {
      display: none !important;
    }

    /* 내용 영역 클릭 차단 (이미지/위시는 그대로) */
    .product-info,
    .price-box {
      pointer-events: none;
    }
  }

  /* 검색 화면용 커머스형 (variant="card"): 한 줄에 2개, 왼쪽에 큰 이미지 */
  /* 주의: 클래스명을 card 로 쓰면 부트스트랩 .card(flex-direction: column)와 충돌한다. */
  /* 썸네일 + 브랜드 로고 열: 카드형에서만 세로로 쌓고, 나머지 화면은 레이아웃에 영향 없게 한다 */
  .thumb-col {
    display: contents;
  }
  &.list-card .thumb-col {
    display: flex;
    flex: 0 0 176px;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    width: 176px;
    .thumb-logo {
      width: 176px;
      height: 46px;
      object-fit: contain;
      cursor: pointer;
      transition: opacity 0.15s;
      &:hover {
        opacity: 0.75;
      }
    }
  }
  &.list-card {
    flex-direction: row;
    align-items: stretch;
    gap: 20px;
    height: 100%;
    padding: 18px;
    border: 1px solid #e6eaee;
    border-radius: 12px;
    background: #fff;
    transition: border-color 0.15s, box-shadow 0.15s, transform 0.15s;

    &:hover {
      border-color: #2563eb;
      box-shadow: 0 6px 20px rgba(29, 79, 128, 0.1);
      transform: translateY(-1px);
    }

    .imgbox {
      flex: 0 0 176px;
      width: 176px;
      height: 176px;
      border: 1px solid #eef1f4;
      border-radius: 10px;
      background: #fff;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    /* 가운데 영역: 위에서부터 브랜드 → 제품명 → 가격, 맨 아래에 제품번호/CAS/사이즈 */
    /* (인라인 height: 140px 가 있어서 !important 로 덮어쓴다) */
    .product-info {
      flex: 1;
      display: flex;
      flex-direction: column;
      width: auto;
      min-width: 0;
      height: auto !important;

      &:hover {
        .subname,
        .name {
          text-decoration: none;
        }
      }
      &:hover .name {
        color: #2563eb;
      }

      .info {
        max-width: none;
        padding-left: 0;

        /* 1) 브랜드 + 제품번호 (한 줄) */
        .brand-line {
          display: flex;
          align-items: baseline;
          flex-wrap: wrap;
          gap: 2px 10px;
          margin: 0 0 4px;

          .brand-name {
            font-size: 0.9rem;
            font-weight: 800;
            letter-spacing: 0.01em;
            color: #2563eb;
            cursor: pointer;

            &:hover {
              text-decoration: underline;
            }
          }

          .item-code {
            display: inline-flex;
            align-items: baseline;
            gap: 5px;
            font-size: 0.8rem;
            color: #9aa4af; /* 라벨(제품번호) */
            cursor: pointer;

            b {
              color: #7c3aed; /* 값 */
              font-weight: 800;
              letter-spacing: 0.01em;
            }

            &:hover b {
              text-decoration: underline;
            }
          }

          /* 브랜드와 제품번호 사이 구분선 */
          .brand-name + .item-code:before {
            content: "";
            display: inline-block;
            align-self: center;
            width: 1px;
            height: 10px;
            margin-right: 5px;
            background: #d9dee3;
          }
        }

        /* 2) 제품명(2줄까지) 아래에 서브명(2줄까지). 넘치면 ..., 전체 이름은 마우스를 올리면 툴팁 */
        .title-text {
          /* 공백이 없는 긴 이름(화학명 등)도 칸을 밀어내지 않고 줄바꿈 */
          overflow-wrap: anywhere;
          word-break: break-word;
        }

        h6.name {
          margin: 0;
          font-size: 1.05rem;
          font-weight: 700;
          line-height: 1.5;
          color: #3730a3;
          -webkit-line-clamp: 2;
        }

        .subname {
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          margin: 2px 0 0;
          font-size: 0.9rem;
          font-weight: 500;
          line-height: 1.45;
          color: #6b7280;
        }

        /* 3) 가격: 윗줄에 할인율 + 원가, 아랫줄에 판매가를 크게 */
        .price-wrapper {
          display: flex;
          align-items: baseline;
          flex-wrap: wrap;
          gap: 2px 8px;
          margin-top: 10px;

          .dicount {
            order: 1;
            margin: 0;
            padding: 0;
            background: none;
            color: #ef4444;
            font-size: 1.05rem;
            font-weight: 900;
          }

          .original-price {
            order: 2;
            padding-top: 0;
            font-size: 0.85rem;
            color: #9aa4af;
          }

          .price {
            order: 3;
            flex: 0 0 100%;
            margin: 0;
            font-size: 1.45rem;
            font-weight: 800;
            line-height: 1.3;
            color: #111827;

            /* 0원: '견적 문의' 버튼 모양 + 작은 메일 주소 */
            .inquiry {
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              gap: 6px;

              .inquiry-btn {
                display: inline-flex;
                align-items: center;
                gap: 7px;
                height: 36px;
                padding: 0 18px;
                border: 1px solid #bcd6ee;
                border-radius: 18px;
                background: #eaf3fb;
                color: #1d4f80;
                font-size: 0.95rem;
                font-weight: 800;
                line-height: 1;
                text-decoration: none;
                /* 0원 행은 .soldOut 에서 클릭이 막혀 있어서, 이 버튼만 눌리게 한다 */
                pointer-events: auto;
                transition: background-color 0.15s, color 0.15s;

                /* 편지봉투 아이콘 (글자색을 따라 바뀐다) */
                &:before {
                  content: "";
                  width: 16px;
                  height: 16px;
                  background-color: currentColor;
                  -webkit-mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Crect x='3' y='5' width='18' height='14' rx='2'/%3E%3Cpath d='M3 7l9 6 9-6'/%3E%3C/svg%3E")
                    center / contain no-repeat;
                  mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Crect x='3' y='5' width='18' height='14' rx='2'/%3E%3Cpath d='M3 7l9 6 9-6'/%3E%3C/svg%3E")
                    center / contain no-repeat;
                }

                &:hover {
                  background: #1d4f80;
                  border-color: #1d4f80;
                  color: #fff;
                }
              }

              .inquiry-mail {
                font-size: 0.78rem;
                font-weight: 400;
                color: #98a2ad;
              }
            }
          }
        }
      }
    }

    /* 4) 제품번호 / CAS No 는 진하게, 사이즈(용량)는 작고 옅게. 카드 맨 아래에 붙인다. */
    .brand-info {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 3px 14px;
      margin-top: auto;
      padding: 12px 0 0;

      > p {
        order: 1;
        margin: 0;
        padding: 0;
        border: none;
        background: none;
        font-size: 0.875rem;
        color: #9aa4af; /* 라벨(제품번호:, CAS No:) */

        span {
          color: #0d9488; /* 값 */
          font-weight: 800;
          letter-spacing: 0.01em;
        }

        &:before {
          display: none;
        }
        &:hover {
          background: none;
          text-decoration: underline;
        }
      }

      .product-option {
        order: 2;
        flex: 0 0 100%;
        font-size: 0.78rem;
        color: #9aa4af;

        span {
          color: #9aa4af;
          font-weight: 400;
        }
      }
    }

    .count-info {
      padding-left: 0;
    }
  }

  /* 상품 상세 헤더 (variant="detail"): 큰 이미지 + 큰 제목/가격 */
  &.list-card.detail {
    gap: 36px;
    padding: 32px;
    border-radius: 16px;
    box-shadow: 0 2px 12px rgba(31, 41, 51, 0.05);
    cursor: default;

    &:hover {
      transform: none;
      border-color: #e6eaee;
      box-shadow: 0 2px 12px rgba(31, 41, 51, 0.05);
    }

    .imgbox {
      flex: 0 0 300px;
      width: 300px;
      height: 300px;
      border-radius: 14px;
    }
    .thumb-col {
      flex: 0 0 300px;
      width: 300px;
      .thumb-logo {
        width: 300px;
        height: 56px;
      }
    }

    .product-info {
      .info {
        .brand-line {
          margin-bottom: 8px;

          .brand-name {
            font-size: 1.05rem;
          }
          .item-code {
            font-size: 0.9rem;
          }
        }

        /* 상세에서는 제목을 줄이지 않고 전부 보여준다 */
        .title-line {
          display: block;
          overflow: visible;
        }

        h6.name {
          display: block;
          font-size: 1.65rem;
          line-height: 1.35;
          -webkit-line-clamp: unset;
          overflow: visible;
        }

        .subname {
          display: block;
          margin-top: 6px;
          font-size: 1.05rem;
          -webkit-line-clamp: unset;
          overflow: visible;
        }

        .price-wrapper {
          margin-top: 24px;

          .dicount {
            font-size: 1.25rem;
          }
          .original-price {
            font-size: 1rem;
          }
          .price {
            font-size: 2.1rem;
          }
        }
      }
    }

    .brand-info {
      gap: 6px 22px;
      margin-top: auto;
      padding-top: 18px;
      border-top: 1px solid #eef1f4;

      > p {
        font-size: 1rem;
      }

      .product-option {
        font-size: 0.9rem;
      }
    }
  }

  .wish-background {
    display: none;
    position: absolute;
    bottom: 8px;
    right: 8px;
    width: 32px;
    height: 32px;
    background: $LIST_BACKGROUND;
    border-radius: 32px;
  }

  .imgbox {
    width: 140px;
    height: 140px;
    border: 1px solid $LINE_DIVIDER;
    border-radius: 4px;
    position: relative;
    overflow: hidden;

    .wish {
      position: absolute;
      bottom: 15px;
      right: 15px;
    }
  }

  .product-info {
    width: calc(100% - 400px);

    .name {
      line-height: 21px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }

    &:hover {
      .subname,
      .name {
        text-decoration: underline;
      }
    }

    .info {
      max-width: 580px;
      padding-left: 20px;

      h6 {
        font-size: 1rem;
        font-weight: 700;
        margin-bottom: 2px;
      }

      .subname {
        margin-bottom: 5px;
        font-size: 0.75rem;
        font-weight: 400;
        color: $COLOR_666;
      }

      .price-wrapper {
        display: flex;

        .dicount {
          color: $PRIMARY_RED;
          margin-right: 10px;
        }

        .price {
          font-size: 1.25rem;
          font-weight: 700;
          margin-bottom: 15px;
          margin-right: 10px;
        }

        .original-price {
          padding-top: 5px;
          font-weight: 400;
          font-size: 16px;
          color: #666;
          text-decoration-line: line-through;
        }
      }
    }
  }

  .brand-info {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    padding-left: 20px;

    > p {
      cursor: pointer;
      display: inline-block;
      position: relative;
      margin-right: 16px;
      font-size: 0.75rem;
      font-weight: 400;
      color: $COLOR_666;

      &:hover {
        text-decoration: underline;
      }

      &:before {
        position: absolute;
        width: 1px;
        height: 12px;
        background-color: $COLOR_DDD;
        content: "";
        right: -8px;
        top: 3px;
      }

      &:last-child {
        &:before {
          display: none;
        }
      }
    }

    .product-option {
      text-decoration: none !important;
      @include ellipse;
    }
  }

  .count-info {
    width: 100%;
    padding-left: 20px;
    color: #ff8248;

    p {
      font-weight: 700;
      font-size: 14px;
    }

    span {
      font-weight: 900;
      font-size: 11px;
    }
  }

  .price-box {
    width: 260px;
    border-left: 1px solid $LINE_DIVIDER;
    box-sizing: border-box;
    margin-left: auto;
    padding-left: 20px;
    height: 140px;
    position: relative;

    ul {
      width: 100%;

      li {
        font-size: 0.75rem;
        display: flex;
        margin-bottom: 8px;

        b {
          font-weight: 400;
        }

        img {
          padding: 0 0 3px 5px;
        }

        .detail-price {
          margin-left: auto;
        }

        &:first-child {
          b {
            font-weight: 700;
          }
          .detail-price {
            color: $PRIMARY_RED;
            font-weight: 700;
          }
        }

        &:hover {
          text-decoration: underline;
        }
      }
    }

    button {
      position: absolute;
      bottom: -8px;
      left: 20px;
      width: calc(100% - 20px);
      height: 36px;
      border: 1px solid #f0f0f0;
      border-radius: 4px;
      font-size: 0.75rem;
      font-weight: 400;
    }
  }
}

/* ---------- 모바일: 카드를 한 줄에 하나, 이미지는 작게 ---------- */
html.is-mobile .product-list-item.list-card {
  .thumb-col {
    flex: 0 0 92px;
    width: 92px;
    gap: 6px;
    .thumb-logo {
      width: 92px;
      height: 28px;
    }
  }
  gap: 12px;
  padding: 12px;

  .imgbox {
    flex: 0 0 92px;
    width: 92px;
    height: 92px;
  }
  .product-info .info {
    .brand-line {
      .brand-name {
        font-size: 0.82rem;
      }
      .item-code {
        font-size: 0.74rem;
      }
    }
    h6.name {
      font-size: 0.95rem;
    }
    .subname {
      font-size: 0.8rem;
    }
    .price-wrapper {
      margin-top: 6px;
    }
  }
}
</style>
